<template>
   <vue-final-modal
      v-model="v310Modal" 
      classes="modal-container"
      content-class="v310-modal-content"
      :drag="true"
      drag-selector=".drug-area"
      @opened="opened()"
      @click-outside="$emit('cancel')"
      >
            <div :tabindex="tabIndexNumber(1)" onfocus="document.getElementById('last_dv').focus()"></div>
      <div class="drug-area">
         <button 
            id="first_dv"
            type="button"
            class="modal__close btn btn-sm" 
            :tabindex="tabIndexNumber(2)" 
            @click="$emit('cancel')"
            >
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg tx-cl-white" viewBox="0 0 16 16">
               <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
            </svg>
         </button>
         <span class="modal__title tx-cl-white">Autorización de medicamentos</span>
      </div>
      <div class="up-voucher p-0 mt-1 border-top border-2">
         <div class="container-fluid m-0 p-0">

            <div class="row justify-content-between mx-0 pb-1 px-1">
               <div class="col-12 col-md-2 px-0">
                  Número: <br>
                  <div class="border rounded ps-1 pb-1">
                     <b>{{ v310Object.id }}</b>
                  </div>
               </div>
               <div class="col-12 col-md-3 px-0">
                  Fecha: <br>
                  <div class="border rounded ps-1 pb-1">
                     <b>{{ v310Object.nowDateTime }}</b>
                  </div>
               </div>
               <div class="col-12 col-md-6 px-0">
                  Operador: <br>
                  <div class="border rounded ps-1 pb-1">
                     <b>{{ v310Object.userName }}</b>
                  </div>
               </div>
               <div class="col-12 px-0 border-top border-2 mt-2"></div>
               <div class="col-12 col-md-5 px-0">
                  CUIL: <br>
                  <div class="border rounded ps-1 pb-1">
                     <b>{{ v310Object.cuil }}</b>
                  </div>
               </div>
               <div v-if="v310Object.cancellationReason" class="col-12 col-md-6 px-0">
                  {{v310Object.cancellationReason.id == 1 ? 'Anula' : 'Complementa'}} Autorización Nro: <br>
                  <div class="border rounded ps-1 pb-1">
                     <b>{{v310Object.requestCanceled}}</b>
                  </div>
               </div>
               <affiliate-data class="col-12 rounded border mt-1" :dataAffiliate="dataAffil" />
               <div class="col-12 col-md-6 px-0">
                  Fecha de Solicitud: <br>
                  <div class="border rounded ps-1 pb-1">
                     <b>{{ v310Object.requestDate }}</b>
                  </div>
               </div>
               <div v-if="v310Rest.cardId" class="col-12 col-md-5 px-0">
                  ID Tarjeta: <br>
                  <div class="border rounded ps-1 pb-1">
                     <b>{{ v310Rest.cardId }}</b>
                  </div>
               </div>
               <div v-else class="col-12 col-md-5 px-0">
                  Nro de Trámite: <br>
                  <div class="border rounded ps-1 pb-1">
                     <b v-if="v310Rest.tramitNumber">{{  v310Rest.tramitNumber }}</b>
                     <b v-else > &nbsp; </b>
                  </div>
               </div>
               <div class="col-12 col-md-5 px-0">
                  Teléfono: <br>
                  <div class="border rounded ps-1 pb-1">
                     <b v-if="v310Rest.phone">{{ v310Rest.phone }}</b>
                     <b v-else > &nbsp; </b>
                  </div>
               </div>
               <div class="col-12 col-md-6 px-0">
                  Especialidad: <br>
                  <div class="border rounded ps-1 pb-1">
                     <b>{{ v310Rest.medicalSpecialties }}</b>
                  </div>
               </div>
               <div class="col-12 px-0 border-top border-2 mt-2">
                  Monodrogas Prescriptas: <br>
                  <div class="border rounded p-1">
                     <table class="table table-sm table-borderless mb-0">
                        <tbody>
                           <tr v-for="(item, index) in v310Rest.diseases310" :key="index"
                                 class="tr-drugs"
                                 >
                              <td class="border py-0 table-light">{{item.disease.name.trim()}}</td>
                              <td class="border py-0 bg-contrast text-end">{{item.disease.pathology.id}}</td>
                              <td class="border py-0 table-light text-end">{{item.disease.id}}</td>
                              <td class="border p-0 table-light">
                                 <div class="row m-0 pe-1">
                                    <div v-for="(monodrug, index) in item.monodrugs310" :key="index"
                                       class="rounded border-contrast col-auto row ms-1 me-0 p-0 pill">
                                       <div class="col-auto px-1 bg-contrast" :title='monodrug.name'>
                                          <span>{{monodrug.code}}</span>
                                       </div>
                                       <div class="col-auto px-1">
                                          {{monodrug.dose}}
                                       </div>
                                    </div>
                                 </div>
                              </td>
                              <!-- <td class="border py-0 table-light text-center">V</td> -->
                           </tr>
                        </tbody>
                     </table>
                     <div v-for="(drug, index) in v310Rest.monodrug310" :key="index" class="fs-14">
                        {{drug.code}} - {{drug.monodrug.name}} - Dosis: {{drug.dose}}
                     </div>
                  </div>
               </div>
               <div class="col-12 px-0 border-top border-2 mt-2">
                  Observaciones Médico: <br>
                  <div class="border rounded ps-1 pb-1">
                     <p style="white-space: pre-line;"><b>{{ v310Rest.doctorsObservations }}</b></p>
                  </div>
               </div>
               <div class="col-12 col-md-4 px-0">
                  Fecha Prescripción: <br>
                  <div class="border rounded ps-1 pb-1">
                     <b>{{ v310Object.prescriptionDate }}</b>
                  </div>
               </div>
               <div class="col-12 col-md-4 px-0">
                  Válido Hasta: <br>
                  <div class="border rounded ps-1 pb-1">
                     <b>{{ v310Object.validDate }}</b>
                  </div>
               </div>
               <div class="col-12 col-md-3 px-0">
                  Matrícula: <br>
                  <div class="border rounded ps-1 pb-1">
                     <b v-if="v310Rest.medicalRegistration">{{ v310Rest.medicalRegistration }}</b>
                     <b v-else > &nbsp; </b>
                  </div>
               </div>
               <!--
               -->
               <div class="col-12 px-0">
                  Observaciones Voucher: <br>
                  <div class="border rounded ps-1 pb-1">
                     <p style="white-space: pre-line;"><b>{{ v310Object.voucherObservations }}</b></p>
                  </div>
               </div>
               <div class="col-12 px-0 border-top border-2 mt-2">
                  Observaciones Internas: <br>
                  <div class="border rounded ps-1 pb-1">
                     <p style="white-space: pre-line;"><b>{{ v310Rest.internalObservations }}</b></p>
                  </div>
               </div>
            </div>
            <!--
            <pre>{{ v310Object }}</pre>
            -->
         </div>
      </div>

      <div class="row p-0 justify-content-between mx-1 border-top border-2 mt-1">
         <user-circle :circleUser="myCircle" class="col-2 mt-2"/>
         <div class="d-flex justify-content-end pt-2 px-0 col-10">
            <button v-if="annulCompl"
                  type="button" 
                  :tabindex="tabIndexNumber(3)" 
                  class="btn btn-outline-light btn-sm me-1" 
                  @click="annulComplValue( 1 )"
                  >
               Anula
            </button>
            <button v-if="annulCompl"
                  type="button" 
                  :tabindex="tabIndexNumber(4)" 
                  class="btn btn-outline-light btn-sm me-1" 
                  @click="annulComplValue( 2 )"
                  >
               Complementa
            </button>
            <button type="button" 
                  id="last_dv"
                  :tabindex="tabIndexNumber(5)" 
                  class="btn btn-outline-light btn-sm me-1" 
                  @click="$emit('cancel')"
                  >
               Salir
            </button>
            <div :tabindex="tabIndexNumber(6)" onfocus="document.getElementById('first_dv').focus()"></div>
         </div>
      </div>
      <!--
      {{ annulCompl }}
      {{ v310Rest }}
      {{ v310Object }}
      -->
   </vue-final-modal>
</template>

<script>


import { VueFinalModal } from 'vue-final-modal'
import { ref, computed } from 'vue';
import { useStore } from 'vuex'

import WspService from '../../workSpace/workSpace.service';
import AnalyService from '../../analytics/analytics.service';

import UserCircle from '../../../components/UserCircle.vue';
import AffiliateData from '../../analytics/components/affiliate/AffiliateDataShow.vue';

export default {

   components: {
      UserCircle,
      VueFinalModal,
      AffiliateData
   },

   props: {
      v310Object: Object,
      v310Rest: Object,
      annulCompl: { 
         type: Boolean,
         default: false
      },
   },

   emits: [ 'cancel' , 'annulComplObj' ],

   setup(props, { emit }) {

      const initialTabIndex = ref(200)
      const v310Modal = ref(true)
      const myCircle = ref({})
      const store = useStore()
      const dataAffil = ref({})
      //

      const testtxt = ref('Dato Prueba')

      const currentUserId = computed(() => {
         return store.state.auth.user.id;
      })

      function annulComplValue( value ) {
         let done = {
            annulCompl: value,
            id: props.v310Object.id
         }
         emit( 'annulComplObj', done)
      }

      function opened() {
         WspService.getMyCircle(currentUserId.value)
         .then(response => {
            console.log(response.data)
            myCircle.value = response.data
         })
         .catch(error => {
            console.log(error);
         })

         AnalyService.getAffiliateBasicData( props.v310Object.cuil )
         .then(response => {
            dataAffil.value = response.data 
         })
         .catch(error => {
            console.log(error)
         })
      }

      function tabIndexNumber( value ) {
         return initialTabIndex.value + value
      }

      
      return {
         annulComplValue,
         dataAffil,
         myCircle,
         opened,
         tabIndexNumber,
         v310Modal,
         testtxt
      }
   }
}
</script>

<style scoped>
::v-deep(.modal-container) {
  display: flex;
  justify-content: center;
  align-items: flex-start;
}
::v-deep(.v310-modal-content) {
  /*
  width: 350px;
  */
  position: relative;
  display: flex;
  flex-direction: column;
  top: 5%;
  min-width: 350px;
  max-width: 750px;
  max-height: 90%;
  padding: 0.00rem 0.25rem 0.25rem 0.25rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background-color: #9E9E9E ;
}
.modal__title {
  margin: 0 2rem 0 0.20rem;
  font-size: 1.25rem;
  font-weight: 450;
}
.modal__close {
  position: absolute;
  top: 0.05rem;
  right: 0.10rem;
}
.up-voucher {
   background-color: #9E9E9E ;
   max-height: calc(100vh - 28px);
   overflow-y: auto;
   color: white;
}
.tx-cl-white {
   color: white;
}
td {
   height: 1.5rem;   
}
.bg-contrast {
   background-color: #d2cece;
}
.border-contrast {
   border: 1px solid #d2cece;
}
.tr-drugs {
   font-size: 0.875rem;
}
td {
   height: 1.5rem;   
}
.pill {
   height: 1.5rem;   
}
</style>
